import * as React from 'react';
import { TaskDisplay } from '@centecomm/portal-service';
import { Close } from '../../Icons';
import { FlexWrapper } from '../../Shared/FlexWrapper';
import TaskSectionDetails from './Sections/TaskSectionDetails';
import DelayTask from './PauseTask';
import styles from './TaskSection.module.css';

const TaskSection: React.FC<{ task: TaskDisplay; clearImportantTaskReminder: () => void }> = ({
    task,
    clearImportantTaskReminder,
}): React.ReactElement => (
    <div className={styles.TaskSection}>
        <FlexWrapper align="stretch" justify="between">
            <h2
                style={{
                    fontSize: '1.5rem',
                    lineHeight: '1.5rem',
                    margin: '0 0 1rem',
                }}
            >
                {task.title}
            </h2>
            <DelayTask task={task} Icon={Close} clearReminder={clearImportantTaskReminder} />
        </FlexWrapper>
        <p style={{ fontSize: '1rem', lineHeight: '1.6', margin: '0 0 1rem' }}>{task.subtitle}</p>
        <TaskSectionDetails task={task} />
    </div>
);

export default TaskSection;
